import { render, staticRenderFns } from "./personalUser.vue?vue&type=template&id=5509c4de&scoped=true&"
import script from "./personalUser.vue?vue&type=script&lang=js&"
export * from "./personalUser.vue?vue&type=script&lang=js&"
import style0 from "./personalUser.vue?vue&type=style&index=0&id=5509c4de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5509c4de",
  null
  
)

export default component.exports